export default __webpack_public_path__ + "i18n/fr.a10af21729a69f5c7193b4b4f62f44ef.json";